module.exports = __webpack_public_path__ + "img/indexType_1.6515c621.png";